import { BannerIcon, BannerStatus } from 'redux/slices/messagingBanner'

import { Theme, navBarHeight } from 'styling/theme'
import checkIcon from 'assets/check-icon.svg'
import { makeStyles } from '@material-ui/core'
import ticketIcon from 'assets/ticket-icon.svg'

export const messagingBannerHeight = 58

export default makeStyles((theme: Theme) => ({
    messagingBanner: {
        zIndex: 2,
        '@media (min-width: 768px)': {
            marginLeft: 16,
            marginRight: 16,

            '@supports (position: sticky)': {
                position: 'sticky',
                top: navBarHeight,
            },
        },
    },

    root: {
        height: messagingBannerHeight,
        width: '100%',
        position: 'relative',
        padding: 12,
        color: theme.colors.white,

        '@media (min-width: 768px)': {
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
    [`status-${BannerStatus.DEFAULT}`]: {
        backgroundImage: `linear-gradient(81deg, rgba(247, 49, 83, 0) 1%, rgba(247, 49, 83, 0.2)), linear-gradient(to bottom, ${theme.colors.brand.blue}, ${theme.colors.brand.blue})`,
    },
    [`status-${BannerStatus.WARNING}`]: {
        backgroundImage:
            'linear-gradient(81deg, rgba(247, 49, 83, 0), rgba(247, 49, 83, 0.2)), linear-gradient(to bottom, #fb7b2e, #fb7b2e)',
    },
    [`status-${BannerStatus.ERROR}`]: {
        backgroundImage: `linear-gradient(261deg, rgba(255, 201, 8, 0.2), rgba(255, 201, 8, 0)), linear-gradient(to bottom, ${theme.colors.brand.pink}, ${theme.colors.brand.pink})`,
    },
    [`status-${BannerStatus.SUCCESS}`]: {
        backgroundImage: `linear-gradient(261deg, rgba(255, 201, 8, 0.2), rgba(255, 201, 8, 0)), linear-gradient(to bottom, #17975d, #17975d)`,
    },
    [`status-${BannerStatus.DISABLED}`]: {
        backgroundImage: `linear-gradient(261deg, ${theme.colors.dark.dark4} 100%, ${theme.colors.light.darkgrey})`,
    },
    body: {
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        maxWidth: 210,

        '@media (min-width: 768px)': {
            maxWidth: 650,
        },
    },
    icon: {
        width: 20,
        height: 20,
        marginRight: 8,
        marginTop: 0,
        background: 'transparent',
        float: 'left',
    },
    iconNoMsg: {
        alignSelf: 'flex-start',
        marginTop: 4,
    },
    [`icon-${BannerIcon.CHECK}`]: {
        background: `url(${checkIcon}) no-repeat center`,
        marginTop: 0,
    },
    [`icon-${BannerIcon.TICKET}`]: {
        marginRight: 6,
        alignSelf: 'baseline',
        marginTop: 3,
        background: `url(${ticketIcon}) no-repeat`,
    },
    showInfo: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 10,
        lineHeight: 1.2,
    },
    message: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginBottom: 2,
        lineHeight: 1.67,
    },
    countdown: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 12,
        lineHeight: 1.67,
        position: 'absolute',
        right: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
}))
